export const TOOLBAR_ICON_BUTTON_SX = {
  alignSelf: 'center',
  fontSize: '1.5rem',
  mx: '1rem',
  color: 'grey.500',
  textTransform: 'none',
}
